import { render, staticRenderFns } from "./UserCreateUpdate.vue?vue&type=template&id=079b1c64&"
import script from "./UserCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./UserCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports